import apiConfig from "src/utils/apiConfig";

export const GET_OWNER = "ownerdetails/fetchOwnerListRequest";


export const GetOwnerDetails = () => {
  const apiObject: any = {
    method: 'GET',
    authentication: true,
    endpoint: apiConfig.GETOWNER,
  };
  return {
    type: GET_OWNER,
    payload: apiObject,
  };
};